import * as Colors from "../../../../../environment/globalStyles/administratorColors";

export const body = {
    paddingRight: "30px",
    // border: "1px solid black",
    height: "100%"
};

export const cardStyle = {
    backgroundColor: Colors.primary,
    color: "white"
};

export const container = {
    paddingTop: "20px"
};

export const errorMessage = {
    color: "red",
    textAlign: "center",
    fontWeight: "bold"
};

export const rightColumn = {
    textAlign: "right"
};

export const settingsTitles = {
    display: "flex",
    flexDirection: "colum",
    alignItems: "center"
};

export const counter = {
    color: "red",
    textAlign: "right"
};

export const topRow = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
};
